import { useContext } from 'react';
import '../style/components/PayMethod.css';
import { config } from '../context/config';
import { ServerRunning } from '../funcs/serverRunning';
import { switchh } from '../context/switch';
import { action } from '../context/action';
import { useNavigate } from 'react-router-dom';
import { collection } from '../context/collect';
import { context } from '../context/context';
import { auth } from '../context/auth';
import useNewInvoice from '../funcs/hooks/useInvoice';
import { useTranslation } from 'react-i18next';
import { CalcDiscount } from '../funcs/calcDiscount';

export default function PayMethod(props) {
    const { t } = useTranslation();
    const { api, lessVisaMoney } = useContext(config);
    const { setLoadingProcess } = useContext(switchh);
    const { cart, invoiceNum, invoiceId } = useContext(context);
    const { setErrorMessage, enablePayOnline } = useContext(action);
    const { ActivEmp } = useContext(auth);
    const { setUrlIframe, client } = useContext(collection);

    const navigator = useNavigate();
    
    const formatPayMobCart = (cart = []) => {
        return cart.map(item => {
            const { result } = CalcDiscount(
                item.discount,
                item.quantity,
                item.price,
                false // get one price one Element 
            );

            return {
                id: item.id,
                name: item.name,
                amount: result,
                quantity: item.quantity ?? 0
            };
        });
    };

    const invoice = useNewInvoice();

    // record the invoice
    const RecordnewPendingInvoice = async () => {

        const InvoiceaddMethodAndStatus = new Array({
            ...invoice,
            method: props.mode === "credit" ? "card" : "mobile wallet",
            status: "pending"
        })
        
        const res = await fetch(`${api}/invoice/create`, {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type":"application/json"
            },
            body: JSON.stringify({data: InvoiceaddMethodAndStatus})
        });

        const result = await res.json();
        if(!result.status) {
            setErrorMessage(result.message);
        }
    }

    const payNow = async () => {
        if (!props.active) return;

        setLoadingProcess(true);
        setErrorMessage("");

        try {
            const server = await ServerRunning();

            if (!server) {
                setErrorMessage(`${t("error:global.serverDown")}...`);
                return;
            }

            if (enablePayOnline.totalVisa < lessVisaMoney) {
                setErrorMessage(`${t("error:paymentOnline.leastAmount", { leastAmount: lessVisaMoney })} ${props.currency}`);
                return;
            }

            const formattedCart = formatPayMobCart(cart);

            const metaData = {
                cart: formattedCart,
                client,
                action: {
                    order: `ORDER=${invoiceNum}|INV=${invoiceId}`,
                    from: ActivEmp?.name || "unknown",
                    pos: props.pos
                },
                money: {
                    payInt: props.mode,
                    amount: Number(enablePayOnline.totalVisa)
                }
            };

            const res = await fetch(`${api}/paymob/generatePaymobLink`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                credentials: "include",
                body: JSON.stringify({ metaData, policy: props.policyStatus })
            });

            const result = await res.json();

            if (!result.status) {
                navigator('/errorPay');
                return;
            }

            await RecordnewPendingInvoice();
            setUrlIframe(result.iframeUrl);

        } catch (error) {
            console.error(error);
            setErrorMessage(t("error:internalServerError"));
        } finally {
            setLoadingProcess(false);
        }
    };

    return (
        <div 
            onClick={payNow}
            className={`box-paymethod flex flex-align-item-center ${!props.active ? "disabled disabled-bg-v2" : ""}`}
        >
            <div
                className="bg-img-pay-method"
                style={{ backgroundImage: `url(${props.img})` }}
            ></div>

            <p className='text-weight-bold'>
                {props.title}
                <small>{!props.active && " - " + t("common:soon")}</small>
            </p>
        </div>
    );
}